<template>
    <div class="bg-a-blue-1c3e95 border border-a-blue-1c3e95 rounded-full text-white h-45px">
        <div class="flex justify-center pt-5px">
            <div class="px-1 text-16 self-center pt-1">{{lbl.topbar.coin}}</div>
            <div class="px-1 text-26 self-center">{{FilterNumberFormat(profile && profile.updated_points? profile.updated_points.points : 0)}}</div>
            <div class="px-1 self-center"><img class="w-4" src="../../../assets/icon/icon-tipcoin.png" /></div>
        </div>
    </div>
</template>

<script>
import AuthPageMixin from '@/mixin/AuthPageMixin'
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'PointLabel',
    mixins: [AuthPageMixin, LocaleMixin],
    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {
         onAccountInit: function() {
            if (this.isLogin) {
                // console.log('profile', this.profile);
            }
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
